import React, {forwardRef, useEffect, useMemo, useRef, useState} from 'react';
import {Accordion, Button, Container} from "react-bootstrap";
import style from './TabResults.module.less'
import './MileStonesTable.less'
import MaterialTable, {MTableHeader, MTableBody, MTableAction,MTableBodyRow} from "material-table";
import {LocalizationWithSmallActions, mapFilesForModal, modifyDefaultOptions} from "../../../../helpers/table";
import TableAction from "./TableAction/TableAction";
import {monthsArray} from "../../../../stores/StratProject/StrategyStore";
import {useStore} from "../../../../stores/StoreHelpers";
import {actionSwitcher} from "../../../../helpers/StrategyProject/stratProjectHelpers";
import useUserContext from "../../../../hooks/useUserContext";
import {StrategyRequests} from "../../../../requests/StrategyRequests/strategyRequests";
import TooltippedElement from "../../../common/TooltippedElement";
import ImageStatus from "./ImageStatus";
import ModalDescription from "../../../common/ModalDescription";
import SlicedTableColumn from "./SlicedTableColumn";
import RenderResponsibleComponent from "./RenderResponsibleComponent";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import FileTableComponent from "../../../FileTableIcon/FileTableComponent";
import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { getProjectTypeText } from '../../../../helpers/typeProject'

const MileStonesTable = (({data, resultId, stratId, api, addToast, mode, projectsFilter, allTablesOpened, type}) => {
    const store = useStore()
    const userCtx = useUserContext()
    const [filesModalOpen,setFilesModalOpen] = useState(null)
    const [resultModalOpen,setResultModalOpen] = useState(null)
    const [statusModalOpen,setStatusModalOpen] = useState(null)
    const [projectsModalOpen,setProjectsModalOpen] = useState(null)
    const requests = useRequestObject({classType:StrategyRequests, stratId, api, addToast, store})
    // const trRef = React.forwardRef(null);
    const getFilesForModal = (isPlan=false) => {
        const files = Object.values(filesModalOpen ?? {}).filter(file=>file.isPlan===isPlan)
        return mapFilesForModal(files,`Документы ${isPlan ? '(план)' : '(факт)'}`)
        // return (
        //     <div className={'mt-lg-4'}>
        //         <h3 style={{fontWeight:600}}>{`Документы ${isPlan ? '(план)' : '(факт)'}`}</h3>
        //         <div className={'mt-lg-4'}>
        //             {Object.values(filesModalOpen ?? {}).filter(file=>file.isPlan===isPlan).map((x,y)=><FileView disabled={true} isDownloadable={true} item={x} index={y} />)}
        //         </div>
        //     </div>
        // )
    }

    const tableData = useMemo(() => mode === 'milestones' ? 
            data.milestones.filter(milestone => {
                const projects = [...milestone.projs, ...milestone.projMilestones.reduce((acc, projMilestone) => [...acc, ...(projMilestone.projs || [])], [])]
                return projectsFilter.length === 0 || projects.some(proj => projectsFilter.some(filterProj => filterProj.fullNumber === proj.fullNumber))
            }) :
            getProjectMilestones(data, projectsFilter), [data, mode, projectsFilter])


    const materialTable = (()=>{
        const getColumns = () => {
            const cols = [
                {
                    title: 'Статус (факт)',
                    field: 'status',
                    editable: 'never',
                    render:(rowData)=> mode === 'milestones' ? <ImageStatus onClick={()=>{setStatusModalOpen(rowData?.comment)}} status={rowData.status} comment={rowData?.comment}/> : null,
                     cellStyle: { width: "calc(5%)",minWidth: '5%',maxWidth: '5%' },
                },
                {
                    title: '№',
                    field: 'num',
                    editable: 'never',
                    cellStyle: { width: "3%",minWidth: '3%',maxWidth: '3%', padding: '16px 4px'},
                    render:(rowData)=> mode === 'milestones' ? <span style={{display:"block"}}>{data?.tableData?.path[0] + 1}.{rowData?.tableData?.path[0] + 1}</span> : null,
                },
                {
                    title: 'Планируемый результат',
                    field: 'name',
                    editable: 'never',
                    cellStyle: { width: "18%",minWidth: '18%',maxWidth: '18%' },
                    render:(rowData)=><span style={{display:"block"}}>{rowData.name}</span>

                },
                {
                    title: 'Фактический результат',
                    field: 'result',
                    editable: 'never',
                    cellStyle: { width: "18%",minWidth: '18%',maxWidth: '18%' },
                    render:(rowData) => <SlicedTableColumn text={rowData?.result} onClick={()=>setResultModalOpen(rowData?.result)} />

                },

                {
                    title: 'Дата вып. (план)',
                    editable: 'never',
                    cellStyle: { width: "calc(10%)",minWidth: '10%',maxWidth: '10%' },
                    render:(rowData)=><>{!(rowData.monthPlan === null || rowData.yearPlan === null) ?`${monthsArray[mode === 'milestones' ? rowData.monthPlan : rowData.monthPlan - 1]}, ${rowData.yearPlan}`:'Не указано'}</>
                },
                {
                    title: 'Дата вып. (факт)',
                    render:(rowData)=><>{!(rowData.monthFact === null || rowData.yearFact === null) ? `${monthsArray[mode === 'milestones' ? rowData.monthFact : rowData.monthPlan - 1]}, ${rowData.yearFact}` : 'Не указано'}</>,
                    editable: 'never',
                    cellStyle: { width: "calc(10%)",minWidth: '10%',maxWidth: '10%'},
                },
                {
                    title: 'УГТ (план)',
                    editable: 'never',
                    cellStyle: { width: "calc(5%)",minWidth: '5%',maxWidth: '5%', whiteSpace:'nowrap' },
                    render:(rowData)=><>{rowData?.trlId ? <StyledTooltip arrow title={store.strategies.trls.find(x=>x.id===rowData.trlId)?.descr}><span style={{fontSize: '14px', textDecoration: 'underline'}}>{rowData.trlId}</span></StyledTooltip> :'-'}</>,
                },
                {
                    title: 'УГТ (факт)',
                    cellStyle: { width: "calc(5%)",minWidth: '5%',maxWidth: '5%', whiteSpace:'nowrap' },
                    editable: 'never',
                    render:(rowData)=><>{rowData?.trlFactId ? <StyledTooltip arrow title={store.strategies.trls.find(x=>x.id===rowData.trlFactId)?.descr}><span style={{fontSize: '14px', textDecoration: 'underline'}}>{rowData.trlFactId}</span></StyledTooltip> :'-'}</>,

                },
                {
                    title: 'Ответственный',
                    editable: 'never',
                    cellStyle: {width: "10%",minWidth: '10%'},
                    render:(rowData => <RenderResponsibleComponent rowData={rowData} />),
                },
                {
                    title: 'Проекты',
                    editable: 'never',
                    cellStyle: {width: "6%",minWidth: '6%',maxWidth: '6%'},
                    render:(rowData => <div className={style.projectsInTable} onClick={() => setProjectsModalOpen(rowData.projs)}>{rowData.projs.map(proj => <>{proj.fullNumber} <br/></>)}</div>),
                },
                {
                    title: 'Док. (шт.)',
                    field: 'files',
                    editable: 'never',
                    cellStyle: {
                        width: '5%',
                        minWidth: '5%',
                    },
                    render:(rowData) => {
                        const milestonesFiles = rowData.files || []
                        return <FileTableComponent data={milestonesFiles.length} onClick={()=>!!milestonesFiles.length && setFilesModalOpen(milestonesFiles)}/>

                    }
                },
            ]
            return [...cols]
        }

       return <Accordion 
            flush 
            activeKey={resultId + mode}  
        >
            <Accordion.Item eventKey={store.strategies.openedTables.some(tab => (tab.opened || []).includes(mode) && tab.id === resultId) ? resultId + mode : ''}>
                <Accordion.Header className={`accordionHeader ${style.accordionHeaderOverride}`} onClick={()=>{
                    store.strategies.changeTableStatus(resultId, mode)
                }}>
                    <span>{mode === 'milestones' ? `Вехи результата «${data.name}»` : `Вехи проектов, влияющие на достижение выдающегося результата/ вехи ${getProjectTypeText(type)}`}</span>
                </Accordion.Header>
                <Accordion.Body className={'bodyOverride'}>
                    <div style={{maxWidth: '100%'}} className={style.findDiv}>
                        <MaterialTable
                            style={{position:'inherit',zIndex:0}}
                            options={modifyDefaultOptions({
                                rowStyle:rowData=>({
                                    display:"flex",
                                }),
                                actionsCellStyle: {
                                    position: 'relative'
                                },
                                headerStyle:{
                                    backgroundColor:'#FFF',
                                    fontWeight:600,
                                    fontSize:'14px',
                                },
                                paging: false,
                                padding:'default',
                                filtering: false,
                                tableLayout:'auto',
                            })}
                            icons={{
                                SortArrow:forwardRef((props, ref) => <></>)
                            }}
                            columns={getColumns()}
                            data={tableData}
                            localization={LocalizationWithSmallActions}
                            components={{
                                Row:(props) => {
                                    const tableData = {...props.data.tableData, path: props.path}
									props.data.tableData = tableData

                                    return <MTableBodyRow {...props} className = {style.mileStoneTableRow}/>
                                },
                                Toolbar:()=><></>,
                                Body:(props)=>(
                                    <div className={style.mileStonesTable}>
                                        <MTableBody {...props}/>
                                    </div>
                                ),
                                Header:(props)=> null,

                                Action: (props) => {
                                    if (!props.action.custom) {
                                        return <MTableAction {...props}  />
                                    }
                                    else {
                                        return mode === 'milestones' ? 
                                            actionSwitcher(props,userCtx,requests,stratId,resultId,(id,status,value) => store.strategies.setCurrentCommentObject(id,status,value)) :
                                            <StyledTooltip title={props.data?.parent?.name}>
                                                <div
                                                 className='projMilestone-action'
                                                 style={{
                                                    border: !!props.data?.parent?.parentId ? '1px solid #ddd' : 'none',
                                                    backgroundColor: !!props.data?.parent?.parentId ? 'white' : '#f4f3ff'
                                                }}
                                                >
                                                    {!!props.data?.parent?.parentId ? 'к вехе результата' : 'к результату'}
                                                </div>
                                            </StyledTooltip>
                                            
                                    }
                                },
                            }}
                            actions={
                                [{
                                    custom: true,
                                    hidden: false,
                                    onClick: () => <TableAction id={data}/>
                                }]
                            }
                        />
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    })



    return ( <div className={style.mileStonesCaption}>
        {materialTable()}
        {<ModalDescription headerText={'Приложенные документы'} onClose={()=>setFilesModalOpen(!filesModalOpen)} show={filesModalOpen}>
            <Container>
                {getFilesForModal(true)}
                {getFilesForModal(false)}
            </Container>
        </ModalDescription>}
        {<ModalDescription className={style.modalDescription} headerText={'Подробное описание'} onClose={()=>setResultModalOpen(null)} show={!!resultModalOpen}>
            <Container>
                <span>{resultModalOpen || ''}</span>
            </Container>
        </ModalDescription>}
        {<ModalDescription className={style.modalDescription} headerText={'Причина отклонения'} onClose={()=>setStatusModalOpen(null)} show={!!statusModalOpen}>
            <Container>
                <span>{statusModalOpen || ''}</span>
            </Container>
        </ModalDescription>}
        <ModalDescription className={style.modalDescription} headerText={'Проекты, влияющие на выполнение вехи'} onClose={() => setProjectsModalOpen(null)} show={!!projectsModalOpen}>
            <Container>
                <ul style={{listStyle: 'none'}}>
                    {(projectsModalOpen || []).map(proj => <li className={style.projectsModalItem}>
                        <NavLink to={`/strats/${proj.strategyId}/projs/${proj.id}`}>{proj.fullNumber} {proj.name}</NavLink>
                    </li>)}
                </ul>
            </Container>
        </ModalDescription>
    </div>);
});

export default MileStonesTable;


function getProjectMilestones(result, projectsFilter){
    const projMilestonesByResultMilestones = (result.milestones || []).reduce((acc, curr) => [...acc, ...curr.projMilestones.map(milestone => ({...milestone, parent: curr}))], [])
    return [
            ...(result.projMilestones || []).map(milestone => ({...milestone, parent: result})),
            ...projMilestonesByResultMilestones
        ].filter(milestone => projectsFilter.length === 0 || milestone.projs.some(proj => projectsFilter.some(filterProj => filterProj.fullNumber === proj.fullNumber)))
}

export const StyledTooltip = styled(({className, ...props}) => (
    <Tooltip {...props} classes={{popper: className}}/>
))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: 12,
        fontFamily: 'Open Sans, sans-serif'
    }
}))